module.exports = __webpack_public_path__ + "img/turkey.808351e.jpg";